import { createFeatureSelector, createSelector } from '@ngrx/store';

import { resetPasswordProperty, ResetPasswordState } from '../reducers';

export const selectResetPassword = createFeatureSelector<ResetPasswordState>(resetPasswordProperty);
export const selectResetPassSuccess = createSelector(selectResetPassword, ({resetPassSuccess}) => resetPassSuccess);
export const selectCheckTokenSuccess = createSelector(selectResetPassword, ({checkTokenSuccess}) => checkTokenSuccess);
export const selectResetPassEmailSubmitted = createSelector(selectResetPassword, ({resetPassEmailSubmitted}) => resetPassEmailSubmitted);
